<template>
  <div
    class="relative w-full max-w-192 h-screen overflow-hidden flex justify-center items-center"
  >
    <div class="slider-cont w-full -mt-17vh">
      <div class="monster-carousel relative block w-0 min-w-full">
        <VueSlickCarousel v-bind="settings">
          <div
            class="monster-slide"
            v-for="(monsterSlide, index) in monsterData"
            :key="index"
          >
            <div
              class="flex flex-col w-full h-full justify-center items-center"
            >
              <div class="flex justify-center">
                <img
                  class="monster-img 2xl:w-full xl:w-9/12 lg:w-8/12"
                  :src="`${imgPath}/Section06/${monsterSlide.monsterImg}`"
                />
              </div>
              <h1
                class="monster-name font-rakkas 2xl:text-7.4 xl:text-7xl lg:text-4.4 leading-7.6 text-very-dark-grayish-blue -mt-20"
                v-html="monsterSlide.name"
              ></h1>
              <p
                class="monster-desc w-5/12 xl:w-5/12 lg:w-7/12 font-mulish-semibold 2xl:text-1.8 xl:text-1.6 lg:text-1.4 leading-2 tracking-wide text-very-dark-gray-2 mt-8 2xl:mt-8 lg:mt-4 text-center"
                v-html="monsterSlide.desc"
              ></p>
            </div>
          </div>
          <template #customPaging="page">
            <div class="dots-wrapper relative custom-dot w-66 h-66 box-content">
              <div
                class="slick-dots-active w-66 h-66 rounded-full absolute inset-center z-10"
              ></div>
              <img
                class="absolute w-66 h-66 inset-center"
                :src="`${imgPath}/Section06/${monsterPaging[page]}`"
              />
            </div>
          </template>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
//import SectionTag from '../components/SectionTag.vue';
export default {
  components: { VueSlickCarousel },
  data: function() {
    return {
      settings: {
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: false,
      },
    };
  },
  methods: {
    resetAnimation: function() {
      this.$store.commit('ANIMATION/RESET_MONSTER_SECTION');
    },
    initAnimation: function() {
      this.$store.commit('ANIMATION/INIT_MONSTER_SECTION');
    },
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      monsterData: state => state.MonsterSection.monsterData,
      monsterPaging: state => state.MonsterSection.monsterPaging,
      pageNumber: state => state.AppConfig.pageNumber,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.monster-carousel >>> .slick-dots {
  @apply w-full max-w-75 flex flex-row justify-between left-0 right-0 -bottom-36 m-auto !important;
}
.monster-carousel >>> .slick-dots li {
  @apply w-66 h-66 mx-6;
}
.monster-carousel >>> .slick-dots li .dots-wrapper .slick-dots-active {
  @apply bg-black bg-opacity-75;
}
.monster-carousel
  >>> .slick-dots
  .slick-active
  .dots-wrapper
  .slick-dots-active {
  @apply bg-opacity-0 bg-transparent shadow-dots-active-2;
}
</style>
